import { render, staticRenderFns } from "./Backtester.vue?vue&type=template&id=5b42953d&"
import script from "./Backtester.vue?vue&type=script&lang=js&"
export * from "./Backtester.vue?vue&type=script&lang=js&"
import style0 from "./Backtester.vue?vue&type=style&index=0&id=5b42953d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports